import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import moment from 'moment'
import styles from '../InternalExternalDetail.module.css'
import SectionHeader from './SectionHeader'
import NoteCard from './NoteCard'
import Button from './Button'
import AddNoteModal from './AddNoteModal'
import DeleteNoteModal from './DeleteNoteModal'
import { getNotes } from '../../../redux/actions'

const ReminderNotesSection = () => {
  const dispatch = useDispatch()
  const { id } = useParams()

  const [addOpen,    setAddOpen]    = useState(false)
  const [editNote,   setEditNote]   = useState(null)
  const [deleteNote, setDeleteNote] = useState(null)

  const notes = useSelector((state) => state.getProfileDetailsReducer?.notes || [])

  useEffect(() => {
    if (id) dispatch(getNotes({ id }))
  }, [id, dispatch])

  const mappedNotes = notes.map((note) => ({
    type: 'actions',
    text: note.Note,
    author: `${note.NotesUserFirstName || ''} ${note.NoteUserLastName || ''}`.trim(),
    posted: `Posted: ${note.Created ? moment(note.Created).format('DD MMM YYYY') : '—'}`,
    _id: note._id,
    StartTime: note.StartTime,
    EndTime: note.EndTime,
  }))

  return (
    <section className={styles.card}>
      <SectionHeader
        title="Reminder Notes"
        action={
          <Button variant="linkBtn" onClick={() => setAddOpen(true)}>
            <span className={styles.plusText}>+</span>
            Add Note
          </Button>
        }
      />

      <p className={styles.helperText}>
        Add a reminder note to help you keep track of important information and come back later.
      </p>

      <div className={styles.notesList}>
        {mappedNotes.map((note, i) => (
          <NoteCard
            key={note._id || i}
            {...note}
            onEdit={() => setEditNote(note)}
            onDelete={() => setDeleteNote(note._id)}
          />
        ))}
      </div>

      <AddNoteModal
        open={addOpen}
        onClose={() => setAddOpen(false)}
        skillListingId={id}
      />
      <AddNoteModal
        open={!!editNote}
        onClose={() => setEditNote(null)}
        note={editNote}
        skillListingId={id}
      />
      <DeleteNoteModal
        open={!!deleteNote}
        onClose={() => setDeleteNote(null)}
        noteId={deleteNote}
      />
    </section>
  )
}

export default ReminderNotesSection
